import { render, staticRenderFns } from "./common-fuzzy.vue?vue&type=template&id=b523d298&"
import script from "./common-fuzzy.vue?vue&type=script&lang=js&"
export * from "./common-fuzzy.vue?vue&type=script&lang=js&"
import style0 from "./common-fuzzy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports